<template>
    <div>
        <div name="query-sort-block">
            <swb-query-sort-area ref="query_model_ctrl" :confKey="confKey" :configAuto="true" :queryOnLoad="true" :onConfigReady="onQueryConfigReady" :queryHandler="queryHandler"></swb-query-sort-area>
        </div>
        <swb-result-table name="result_table" ref="result_table" :confKey="confKey" :configAuto="true" :needPager="needPager" :multiSelect="multiSelect" :multiPageSelect="multiPageSelect" :rowKeyPropName="rowKeyPropName" :rowNoShow="rowNoShow" :rowNoFixed="rowNoFixed" :btnColName="btnColName" :btnColTitle="btnColTitle" :btnColWidth="btnColWidth" :btnColFixed="btnColFixed" :height="tableHeight" :pageNoChangeHandler="pageNoChangeHandler" :rowDblClickHandler="rowDblClickHandler"></swb-result-table>
    </div>
</template>

<script>

    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'
    import { getDefaultPageSizes } from '../../app.conf'
    //
    import shopComnReqApi from '../../api/shopComnReq'
    //
    export default {
        name: 'swb-shop-comn-repair-list-for-select',
        desc: '常规服务请求列表选择',
        props: {
            checkBox: {
                type: Boolean,
                default: false
            },
            checkedIds: {// 多选的时候传入
                type: Array,
                default: function () {
                    return [];
                }
            },
            disableInitCheckedSelection: { // 禁用初始选中的（多选的时候传）
                type: Boolean,
                default: false
            },
            bizUnitId: {
                type: Number,
                default: null
            },
            servcTypeId: {
                type: Number,
                default: null
            }
        },
        data: function () {
            return {
                confKey: 'swb-shop-comn-repair-list-for-select',
                tableHeight: 500,
                needPager: true, //是否需要分页（默认：true）
                multiSelect: false, //是否多选（默认：false）
                multiPageSelect: false, //是否要多页/跨页选择（默认：false）
                rowKeyPropName: "id", //记录数据关键标识列名（多页/跨页选择必须，默认: id）
                rowNoShow: false, //是否显示行号（默认：true）
                rowNoFixed: false, //行号列是否固定（默认：false）
                //
                btnColName: '',//操作列名称（如果不设置就不显示操作列）
                btnColTitle: '操作',//操作列标题（默认：'操作'）
                btnColWidth: 250,//操作列宽度（默认：100）
                //
                btnColFixed: true, //操作列是否固定
                //
                pageNumber: 1,
                pageSize: null,
                pageSizes: getDefaultPageSizes(),
                //
                shopComnRepairList: [],
                //
                queryModel: {
                    filterItems: {},
                    sortItemList: [],
                    sortItems: {}
                },
                //
                getRowKeys(row) {
                    return row.id;
                },
                selectIdMap: {},
                //
                selectDevice: null,
                selectDeviceList: [],
            }
        },
        created: function () {
            //保持pageSize的一致性
            this.pageSize = this.pageSizes.first();
            //
            this.multiSelect = this.checkBox;
            this.multiPageSelect = this.checkBox;
            this.getShopComnRepairList();
        },
        mounted() {
            //
            this.initResultTable();
            //回显数据处理
            let resultTable = this.$refs.result_table;
            resultTable.setInitChecked(this.checkedIds, this.disableInitCheckedSelection);
        },
        destroyed() {
            //释放domSizeWatcher
            let domSizeWatcher = this.domSizeWatcher;
            if(domSizeWatcher != null) {
                domSizeWatcher.clear();
                this.domSizeWatcher = null;
            }
        },
        methods: {
            //
            onQueryConfigReady: function () {
                // 卖家类型
                let servcTypeList = getEnumList("servcType");
                let dataList = [];
                dataList.push({"value": null, "label": "- 全部 -"});
                for(let i = 0; i < servcTypeList.length; i++) {
                    let servcTypeInfo = servcTypeList[i];
                    let item = {
                        value: servcTypeInfo.value,
                        label: servcTypeInfo.text
                    };
                    dataList.push(item);
                }
                this.updateQueryModelField("servcTypeId", dataList);
            },
            updateQueryModelField: function (itemCode, dataList = []) {
                if(itemCode != null) {
                    let query_model_ctrl = this.$refs['query_model_ctrl'];
                    let data = {dataList: dataList};
                    let fieldInfo = {};
                    fieldInfo[itemCode] = data;
                    query_model_ctrl.updateFields(fieldInfo);
                }
            },
            initResultTable(){
                let self = this;
                let query_model_ctrl = this.$refs['query_model_ctrl'];
                let resultTable = this.$refs['result_table'];
                //关联[列配置对象]到结果表格（结果表格可以实时利用最新的列配置，同时结果表格列宽也会反向同步到[列配置对象]中去）
                resultTable.setQrySortRef(query_model_ctrl);
                //
                resultTable.initMeta(/* confColList, */ /* 单元格html渲染函数 */{
                    'referred': function (row, colName, colValue, rowIndex, colConf) {
                        if(colValue) {
                            return '<span class="font-green">是</span>';
                        } else {
                            return '<span>否</span>';
                        }
                    },
                    'servicerFlag': function (row, colName, colValue, rowIndex, colConf) {
                        if(colValue) {
                            return '<span class="font-green">是</span>';
                        } else {
                            return '<span>否</span>';
                        }
                    },
                    'grabIssueAllowed': function (row, colName, colValue, rowIndex, colConf) {
                        if(colValue) {
                            return '<span class="font-green">是</span>';
                        } else {
                            return '<span>否</span>';
                        }
                    },
                    'disabled': function (row, colName, colValue, rowIndex, colConf) {
                        if(colValue) {
                            return '<span class="font-green">是</span>';
                        } else {
                            return '<span>否</span>';
                        }
                    },
                    'actions': function (row, colName, colValue, rowIndex) {
                    }
                }, /* 单元格按钮点击处理函数 */{
                    //*代表可处理未指定事件函数的任意列的按钮/链接的点击
                    'actions': function (row, colName, colValue, rowIndex, btnName) {
                    }
                });
            },
            renderTable(rows, pagination) {
                //
                let resultTable = this.$refs.result_table;
                //清除数据（如果已经渲染的数据与新的列不是一回事儿）
                //resultTable.clear();
                //同步使用新的自定义列信息
                //resultTable.initMeta(confColList);
                //设置新数据
                let tableData = {
                    rows: rows,
                    pagination: pagination
                };
                resultTable.render(tableData);
            },
            // 单元格点击事件
            rowDblClickHandler: function (row) {
                if(!this.multiSelect) {
                    console.log("----- 双击数据行 ----");
                    console.log(row);
                }
            },
            //
            queryHandler(queryModel) {
                this.pageNumber = 1;
                //缓存查询条件
                this.queryModel = queryModel;
                this.getShopComnRepairList();
            },
            pageNoChangeHandler: function (pageNumber, pageSize) {
                console.log("分页 => 第【" + pageNumber + "】页，大小：" + pageSize);
                //
                this.pageSize = pageSize;
                this.pageNumber = pageNumber;
                //
                this.getShopComnRepairList();
            },
            //
            getShopComnRepairList: function () {
                let self = this;
                let postData = {};
                postData.pagination = {
                    pageSize: self.pageSize,
                    pageNumber: self.pageNumber,
                };
                postData.filterItems = Utils.merge({}, this.queryModel.filterItems);
                postData.sortItemList = Utils.merge([], this.queryModel.sortItemList);
                postData.sortItems = Utils.merge({}, this.queryModel.sortItems);
                postData.filterItems.comId = self.bizUnitId;
                postData.filterItems.servcTypeId = self.servcTypeId;
                postData.filterItems.disabled = false;

                let theLoad = MsgBox.loading();
                shopComnReqApi.getShopComnRepairPagedList(postData, function (result) {
                    theLoad.hide();
                    if(result.type == 'info') {
                        let shopComnRepairList = result.data.rows || [];
                        self.shopComnRepairList = Utils.merge([], shopComnRepairList);
                        //
                        self.totalCount = result.data.pagination.totalCount;
                        self.renderTable(self.shopComnRepairList, result.data.pagination);
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            getTableSelection() {
                let resultTable = this.$refs.result_table;
                return resultTable.getSelection();
            },
            getDlgResult: function () {
                let selectList = this.getTableSelection();
                //
                let result = {};
                if(Utils.isTrue(this.checkBox)) {
                    selectList = selectList || [];
                    if(selectList.length <= 0) {
                        result.type = "warn";
                        result.message = "请选择常规服务需求！";
                        return result;
                    }
                } else {
                    if(Utils.isNoB(selectList)) {
                        result.type = "warn";
                        result.message = "请选择常规服务需求！";
                        return result;
                    }
                }
                result.type = "info";
                result.data = selectList;
                return result;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/shopComnReq/ShopComnRepairForSelect.vue